<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      <meta content="" name="description" />
      <meta content="" name="keywords" />

      <!-- Favicons -->
      <link href="niceAdmin/assets/img/favicon.png" rel="icon" />
      <link
        href="niceAdmin/assets/img/apple-touch-icon.png"
        rel="apple-touch-icon"
      />

      <!-- Google Fonts -->
      <link href="https://fonts.gstatic.com" rel="preconnect" />
      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Nunito:300,300i,400,400i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
        rel="stylesheet"
      />

      <!-- Vendor CSS Files -->
      <link
        href="niceAdmin/assets/vendor/bootstrap/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/bootstrap-icons/bootstrap-icons.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/boxicons/css/boxicons.min.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/quill/quill.snow.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/quill/quill.bubble.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/remixicon/remixicon.css"
        rel="stylesheet"
      />
      <link
        href="niceAdmin/assets/vendor/simple-datatables/style.css"
        rel="stylesheet"
      />

      <!-- Template Main CSS File -->
      <link href="niceAdmin/assets/css/style.css" rel="stylesheet" />
    </head>

    <DashboardHeader title="Dashboard">
      <body>
        <div class="mx-4">
          <div class="pagetitle">
            <h1>Dashboard</h1>
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                <li class="breadcrumb-item active">Dashboard</li>
              </ol>
            </nav>
          </div>
          <!-- End Page Title -->

          <section class="section dashboard">
            <div class="row">
              <!-- Right side columns -->
              <div class="col-lg-4">
                <!-- Recent Activity -->
                <div class="card">
                  <div class="filter">
                    <a class="icon" href="#" data-bs-toggle="dropdown"
                      ><i class="bi bi-three-dots"></i
                    ></a>
                  </div>

                  <div class="card-body">
                    <v-alert color="warning" dark
                      >Choose Context
                      <v-autocomplete
                        label="Select Context"
                        v-model="dashboardContext"
                        :items="[
                          { text: 'Company', value: 'company' },
                          { text: 'Client', value: 'client' },
                          { text: 'Staff', value: 'staff' },
                        ]"
                        @input="changeContextToCompany"
                      ></v-autocomplete>
                    </v-alert>

                    <v-alert color="teal" dark>
                      <v-autocomplete
                        :label="'Select ' + clientLabel"
                        v-model="selectContextObject"
                        :items="clients"
                        @input="changeContextToClient"
                      ></v-autocomplete>
                    </v-alert>

                    <v-alert color="primary" dark>
                      <v-autocomplete
                        label="Select Staff"
                        v-model="selectContextObject"
                        :items="allStaffForSelect"
                        @input="changeContextToStaff"
                      ></v-autocomplete>
                    </v-alert>
                  </div>
                </div>
                <!-- End Recent Activity -->

                <!-- Budget Report -->
                <div class="card">
                  <SendSMS
                    v-if="(bulkSMS = true)"
                    :groupTable="groupTable"
                    :recipientsIDs="selectedMembersForSMSSending"
                    @refresh-needed="refreshAnalyticsData"
                    :selectedSentSMSItem="selectedSentSMSItem"
                  ></SendSMS>
                </div>
                <!-- End Budget Report -->

                <!-- News & Updates Traffic -->
                <div class="card">
                  <div class="card-body pb-0">
                    <h5 class="card-title">
                      {{
                        `${capitalizeFirstCharacter(dashboardContext)} Profile`
                      }}
                    </h5>
                    <PersonalProfileComponent
                      v-if="!isMobile"
                      :profile="selectContextObject"
                      :title="dashboardContext"
                      imageFolder="logos"
                    ></PersonalProfileComponent>
                    <v-expansion-panels v-else class="pb-4">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          {{
                            `${capitalizeFirstCharacter(
                              dashboardContext
                            )} Profile`
                          }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <PersonalProfileComponent
                            v-if="!isMobile"
                            :profile="selectContextObject"
                            :title="dashboardContext"
                            imageFolder="logos"
                          ></PersonalProfileComponent>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <!-- End sidebar recent posts-->
                  </div>
                </div>
                <!-- End News & Updates -->

                <!-- Website Traffic -->
                <div class="card">
                  <!-- <div class="filter">
                    <a class="icon" href="#" data-bs-toggle="dropdown"
                      ><i class="bi bi-three-dots"></i
                    ></a>
                  </div> -->

                  <div class="card-body pb-0">
                    <h2 class="card-title">
                      {{ `Edit ${capitalizeFirstCharacter(dashboardContext)}` }}
                    </h2>
                    <ClientDetail
                      v-if="!isMobile"
                      :client="selectContextObject"
                      :table="groupTable"
                    ></ClientDetail>
                    <v-expansion-panels v-else class="pb-4">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          {{
                            `Edit ${capitalizeFirstCharacter(dashboardContext)}`
                          }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <ClientDetail
                            :client="selectContextObject"
                            :table="groupTable"
                          ></ClientDetail>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
                <!-- End Website Traffic -->
              </div>
              <!-- End Right side columns -->

              <!-- Left side columns -->
              <div class="col-lg-8">
                <div class="row">
                  <!-- Sales Card -->
                  <div class="col-xxl-4 col-md-4">
                    <div class="card info-card sales-card">
                      <div class="filter">
                        <a class="icon" href="#" data-bs-toggle="dropdown"
                          ><i class="bi bi-three-dots"></i
                        ></a>
                      </div>

                      <div class="card-body">
                        <h5 class="card-title">
                          {{ topBoxes.boxOneText }}
                          <span>| {{ topBoxes.boxOnePeriod }}</span>
                        </h5>

                        <div class="d-flex align-items-center">
                          <div
                            class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                          >
                            <i class="bi bi-cart"></i>
                          </div>
                          <div class="ps-3">
                            <h6>
                              {{
                                dashboardContext == "staff"
                                  ? topBoxes.boxOneValue
                                  : `${getCurrency} ${formatMoney(
                                      topBoxes.boxOneValue
                                    )}`
                              }}
                            </h6>
                            <!-- <span class="text-success small pt-1 fw-bold"
                            >12%</span
                          >
                          <span class="text-muted small pt-2 ps-1"
                            >increase</span
                          > -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Sales Card -->

                  <!-- Revenue Card -->
                  <div class="col-xxl-4 col-md-4">
                    <div class="card info-card revenue-card">
                      <div class="filter">
                        <a class="icon" href="#" data-bs-toggle="dropdown"
                          ><i class="bi bi-three-dots"></i
                        ></a>
                      </div>

                      <div class="card-body">
                        <h5 class="card-title">
                          {{ topBoxes.boxTwoText }}
                          <span>| {{ topBoxes.boxTwoPeriod }}</span>
                        </h5>

                        <div class="d-flex align-items-center">
                          <div
                            class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                          >
                            <v-icon>mdi-receipt</v-icon>
                          </div>
                          <div class="ps-3">
                            <h6>
                              {{
                                `${getCurrency} ${formatMoney(
                                  topBoxes.boxTwoValue
                                )}`
                              }}
                            </h6>
                            <!-- <span class="text-success small pt-1 fw-bold"
                            >8%</span
                          >
                          <span class="text-muted small pt-2 ps-1"
                            >increase</span
                          > -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Revenue Card -->

                  <!-- Customers Card -->
                  <div class="col-xxl-4 col-md-4">
                    <div class="card info-card customers-card">
                      <div class="filter">
                        <a class="icon" href="#" data-bs-toggle="dropdown"
                          ><i class="bi bi-three-dots"></i
                        ></a>
                      </div>

                      <div class="card-body">
                        <h5 class="card-title">
                          {{ topBoxes.boxThreeText }}
                          <span>| {{ topBoxes.boxThreePeriod }}</span>
                        </h5>

                        <div class="d-flex align-items-center">
                          <div
                            class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                          >
                            <i class="bi bi-people"></i>
                          </div>
                          <div class="ps-3">
                            <h6>
                              {{
                                `${getCurrency} ${formatMoney(
                                  topBoxes.boxThreeValue
                                )}`
                              }}
                            </h6>
                            <!-- <span class="text-danger small pt-1 fw-bold"
                            >12%</span
                          >
                          <span class="text-muted small pt-2 ps-1"
                            >decrease</span
                          > -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Customers Card -->

                  <!-- Reports -->
                  <div class="col-12">
                    <div class="card">
                      <div class="filter">
                        <a class="icon" href="#" data-bs-toggle="dropdown"
                          ><i class="bi bi-three-dots"></i
                        ></a>
                      </div>

                      <div class="card-body">
                        <h5 class="card-title">Reports <span>/Today</span></h5>

                        <!-- Line Chart -->
                        <div id="reportsChart">
                          <v-row align="center" justify="space-around">
                            <v-col :cols="isMobile ? 12 : 4"
                              ><v-btn
                                depressed
                                color="red"
                                x-large
                                block
                                @click="openAddClient"
                                dark
                              >
                                Add {{ clientLabel }}
                              </v-btn></v-col
                            >
                            <v-col :cols="isMobile ? 12 : 4"
                              ><v-btn
                                depressed
                                color="warning"
                                x-large
                                block
                                @click="openAddStaff"
                              >
                                Add Staff
                              </v-btn></v-col
                            >
                            <v-col :cols="isMobile ? 12 : 4"
                              ><v-btn
                                depressed
                                color="teal"
                                x-large
                                block
                                dark
                                @click="openAddInvoice"
                              >
                                Create Invoice
                              </v-btn></v-col
                            >
                          </v-row>
                        </div>

                        <!-- End Line Chart -->
                      </div>
                    </div>
                  </div>
                  <!-- End Reports -->

                  <!-- Recent Sales -->
                  <div class="col-12">
                    <div class="card recent-sales overflow-auto">
                      <FullCalendar
                        :staff="selectedStaff"
                        :client="selectedClient"
                      ></FullCalendar>
                    </div>
                  </div>
                  <!-- End Recent Sales -->

                  <!-- Top Selling -->
                  <div class="col-12">
                    <div class="card top-selling overflow-auto">
                      <DashboardTiles :tiles="tiles"></DashboardTiles>
                    </div>
                  </div>
                  <!-- End Top Selling -->
                </div>
              </div>
              <!-- End Left side columns -->
            </div>
          </section>
        </div>
        <!-- End #main -->

        <!-- ======= Footer ======= -->
        <footer id="footer" class="footer">
          <div class="copyright">
            &copy; Copyright <strong><span>Baron IT Solutions</span></strong
            >. All Rights Reserved
          </div>
        </footer>
        <!-- End Footer -->

        <a
          href="#"
          class="back-to-top d-flex align-items-center justify-content-center"
          ><i class="bi bi-arrow-up-short"></i
        ></a>
      </body>
    </DashboardHeader>
    <GlobalDialogSlot
      :dialog="dialog"
      :title="dialogTitle"
      @close-dialog="closeDialog"
      :maxWidth="maxWidth"
    >
      <div v-if="dialogContext == 'add-staff'">
        <CreateStaff @staff-created="initialiseDashboard"></CreateStaff>
      </div>
      <div v-else-if="dialogContext == 'add-client'">
        <CreateClient @client-created="initialiseDashboard"></CreateClient>
      </div>
      <div v-else-if="dialogContext == 'add-invoice'">
        <CreateInvoice
          :selectedInvoiceProp="null"
          :docType="'Invoice'"
        ></CreateInvoice>
      </div>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/plugins/axios";
import baronjs from "@/plugins/baron";
import clientsJs from "@/plugins/clients";

import eventsJs from "@/plugins/events";
import staffJs from "@/plugins/staff";
import helperJs from "@/plugins/helpers";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import FullCalendar from "@/components/EventsCalendar/FullCalendar.vue";
import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";
import SendSMS from "@/components/SMS/SendSMS.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
import ClientDetail from "@/components/Clients/ClientDetail.vue";
import PersonalProfileComponent from "@/components/myLibrary/PersonalProfileComponent.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import CreateStaff from "@/components/StaffAndHR/CreateStaff.vue";
import CreateClient from "@/components/Clients/CreateClient.vue";
import CreateInvoice from "@/components/InvoicesAndQuotes/CreateInvoice.vue";

export default {
  components: {
    FullCalendar,
    DashboardTiles,
    SendSMS,
    DashboardHeader,
    ClientDetail,
    PersonalProfileComponent,
    GlobalDialogSlot,
    CreateStaff,
    CreateClient,
    CreateInvoice,
  },
  computed: mapGetters([
    "getApiUrl",
    "getLogo",
    "getAccessToken",
    "getUserCompany",
    "getCurrentUser",
    "getThemeColor",
    "isManager",
    "isAdmin",
    "isStaff",
    "getCompanyLabels",
    "isGuest",
    "isEverybody",
    "isEverybodyEA",
    "getCurrency",
    "isMobile",
  ]),
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    this.renameClient();
    await this.initialiseDashboard();
    this.setUserEmis();
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    this.renameClient();
  },
  data: () => ({
    maxWidth: "550",
    dashboardContext: "company",
    selectContextObject: null,
    selectedMembersForSMSSending: [],
    selectedSentSMSItem: null,
    invoicesData: null,
    invoices: [],
    clients: [],
    clientLabel: null,
    allStaffOriginalObjs: [],
    allStaffForSelect: [],
    allEvents: [],
    groupTable: null,
    selectedClient: null,
    selectedStaff: null,
    topBoxes: {
      boxOneText: null,
      boxOneValue: 0,
      boxOnePeriod: "This Year",
      boxTwoText: null,
      boxTwoValue: 0,
      boxTwoPeriod: "This Year",
      boxThreeText: null,
      boxThreeValue: 0,
      boxThreePeriod: "This Year",
    },
    allEventsAndAppointments: [],
    dialogContext: null,
    dialog: false,
    dialogTitle: "",
    tiles: [
      {
        id: 2,
        icon: "mdi-cart-arrow-right",
        title: "Products",
        industry: ["Store", "IT"],
        route: "manage-products",
        param: "",
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },

      {
        id: 3,
        icon: "mdi-network-pos",
        title: "POS",
        industry: ["Store"],
        route: "point-of-sale",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 3,
        icon: "mdi-network-pos",
        title: "Activity Tracker",
        industry: ["General"],
        route: "activity-tracker",
        param: "",
        alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 3,
        icon: "mdi-account-group",
        title: "Talents",
        industry: ["Agency"],
        route: "manage-talents",
        param: "",
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },

      {
        id: 3,
        icon: "mdi-receipt",
        title: "Invoices",
        industry: ["General"],

        route: "invoices-and-quotes",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 7,
        icon: "mdi-pencil",
        title: "Edit Any Data",
        industry: ["General"],

        route: "data-crud",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 2,
        icon: "mdi-account-multiple",
        title: "Clients",
        industry: ["General"],
        route: "manage-clients",
        param: "",
        alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },

      {
        id: 2,
        icon: "mdi-file",
        title: "Filing",
        industry: ["Legal Practice"],
        route: "manage-files",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },

      // {
      //   id: 3,
      //   icon: "mdi-Company",
      //   title: "E-learning",
      //   industry: ["General"],

      //   route: "elearning",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter"
      // },
      // {
      //   id: 3,
      //   icon: "mdi-Company",
      //   title: "Billings",
      //   industry: ["General", "Legal Practice"],
      //   route: "billings",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 3,
      //   icon: "mdi-store",
      //   title: "Store",
      //   industry: ["General"],

      //   route: "web-store",
      //   param: "",
      //   alevel: [1,2,3,4,5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      {
        id: 9,
        icon: "mdi-comment",
        title: "Bulk SMS",
        industry: ["General"],
        route: "bulk-sms-dashboard",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 9,
        icon: "mdi-mail",
        title: "Emails",
        industry: ["General"],

        route: "bulk-emails-dashboard",
        param: "",
        alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      // {
      //   id: 2,
      //   icon: "mdi-office",
      //   title: "Word",
      //   industry: ["General", "Legal Practice"],
      //   route: "word-editor",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 2,
      //   icon: "mdi-office",
      //   title: "Explorer",
      //   industry: ["General", "Legal Practice"],
      //   route: "file-manager",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      {
        id: 9,
        icon: "mdi-account-multiple",
        title: "HR & Staff",
        industry: ["General"],
        route: "manage-employees",
        param: "",
        alevel: [9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      // {
      //   id: 9,
      //   icon: "mdi-account-cash",
      //   title: "Payslips",
      //   industry: ["General"],

      //   route: "salaries-and-payslips",
      //   param: "",
      //   alevel: [9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 4,
      //   icon: "mdi-credit-card-marker-outline",
      //   title: "Pay Online",
      //   industry: ["General", "Legal Practice"],

      //   route: "pay-online",
      //   param: "",
      //   alevel: [3, 4, 5, 6, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 7,
      //   icon: "mdi-file",
      //   title: "Reports",
      //   industry: ["General", "Legal Practice"],

      //   route: "data-and-reports",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      // {
      //   id: 9,
      //   icon: "mdi-calendar",
      //   title: "Events",
      //   industry: ["General"],

      //   route: "events-calendar",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
      {
        id: 9,
        icon: "mdi-file",
        title: "Images",
        industry: ["General"],

        route: "website-dashboard",
        param: "",
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      {
        id: 9,
        icon: "mdi-cog",
        title: "Company Profile",
        industry: ["General"],

        route: "settings",
        param: "",
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },

      {
        id: 9,
        icon: "mdi-account-multiple",
        title: "Manage Users",
        industry: ["General"],

        route: "manage-users",
        param: "",
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        buttonText: "Enter",
      },
      // {
      //   id: 10,
      //   icon: "mdi-card-account-mail",
      //   title: "Enquiries",
      //   industry: ["General", "Legal Practice"],

      //   route: "",
      //   param: "",
      //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },

      // {
      //   id: 10,
      //   icon: "mdi-play",
      //   title: "Tutorials",
      //   industry: ["General"],
      //   route: "video-tutorials",
      //   param: "",
      //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      //   buttonText: "Enter",
      // },
    ],
  }),
  methods: {
    renameClient() {
      this.clientLabel = this.getCompanyLabels.client;
      this.tiles.forEach((tile) => {
        if (tile.title == "Clients") {
          tile.title = this.getCompanyLabels.client;
        }
      });
    },
    refreshAnalyticsData() {
      //console.log()
    },
    formatMoney(amount) {
      return helperJs.formatMoney(amount);
    },
    async getInvoicesAndQuotesData() {
      this.$store.commit("setLoader", true);
      this.invoicesData = await invoicesAndQuotesJs.getInvoicesAndQuotesData();
      this.getAndSetCompanyInvoicesData(this.invoicesData.invoices);
      this.getLogos(this.getUserCompany.emis);
      this.$store.commit("setLoader", false);
    },
    getAndSetCompanyInvoicesData(invoices) {
      this.topBoxes.boxOneText = "Total Invoices";
      this.topBoxes.boxTwoText = "Total Paid";
      this.topBoxes.boxThreeText = "Total Outstanding";

      this.topBoxes.boxOneValue = 0;
      this.topBoxes.boxTwoValue = 0;
      this.topBoxes.boxThreeValue = 0;

      if (invoices.length > 0) {
        invoices.forEach((invoice) => {
          if (invoice && invoice.calculation) {
            this.topBoxes.boxOneValue += Number(invoice.calculation.total);
            this.topBoxes.boxTwoValue += Number(invoice.totalPayment);
            this.topBoxes.boxThreeValue +=
              Number(invoice.calculation.total) - Number(invoice.totalPayment);
          }
        });
      }

      // if (this.invoicesData && this.invoicesData.quotations) {
      //   this.quotes = this.invoicesData.quotations;
      //   this.financeTotal[0]["amount"] = 0;
      //   this.invoicesData.quotations.forEach((quote) => {
      //     if (quote && quote.calculation) {
      //       this.financeTotal[0]["amount"] += Number(quote.calculation.total);
      //     }
      //   });
      // }
    },
    capitalizeFirstCharacter(str) {
      return helperJs.capitalizeFirstCharacter(str);
    },
    async initialiseDashboard() {
      this.clientLabel = this.getCompanyLabels.client;
      this.$store.commit("setLoader", true);
      this.selectContextObject = this.getUserCompany;
      if (this.dashboardContext == "company") {
        this.groupTable = "companies";
      } else if (this.dashboardContext == "client") {
        this.groupTable = "clients";
      } else if (this.dashboardContext == "staff") {
        this.groupTable = "staff";
      }
      await this.getInvoicesAndQuotesData();
      await this.getAllClients();
      await this.getAllStaff();
      this.$store.commit("setLoader", false);
    },
    async changeContextToCompany() {
      if (this.dashboardContext == "company") {
        this.groupTable = "companies";
        this.selectedClient = null;
        this.selectedStaff = null;
        this.selectContextObject = this.getUserCompany;
        await this.getInvoicesAndQuotesData();
      }
    },
    changeContextToClient() {
      this.dashboardContext = "client";
      this.groupTable = "clients";
      this.selectedClient = this.selectContextObject;
      if (this.invoicesData.invoices.length > 0) {
        const invoices = this.invoicesData.invoices.filter((invoice) => {
          return invoice.client_reference == this.selectContextObject.id_number;
        });
        this.getAndSetCompanyInvoicesData(invoices);
      }
    },
    async getAllAppointmentsCurrentMonth() {
      this.allEventsAndAppointments =
        await eventsJs.getAllAppointmentsCurrentMonth(
          this.getUserCompany.emis,
          "Yes"
        );
    },
    async changeContextToStaff() {
      this.dashboardContext = "staff";
      this.groupTable = "staff";
      this.selectedStaff = this.selectContextObject;
      this.$store.commit("setLoader", true);
      await this.getAllAppointmentsCurrentMonth();
      if (this.allEventsAndAppointments.length > 0) {
        const allEventsAndAppointmentsForStaff =
          this.allEventsAndAppointments.filter((appointment) => {
            return appointment.staff_id == this.selectContextObject.id;
          });

        let staffPayout = 0;
        let staffHours = 0;
        let totalAllPayout = 0;
        this.allEventsAndAppointments.forEach((appointment) => {
          totalAllPayout =
            Number(totalAllPayout) +
            Number(
              (Number(appointment.rates) * Number(appointment.hours)).toFixed(2)
            );
        });
        this.topBoxes.boxThreeText = "Total Payout To All Talents";
        this.topBoxes.boxThreePeriod = "This Month";
        this.topBoxes.boxThreeValue = totalAllPayout;

        allEventsAndAppointmentsForStaff.forEach((appointment) => {
          staffPayout += Number(
            (Number(appointment.rates) * Number(appointment.hours)).toFixed(2)
          );
          staffHours += Number(appointment.hours);
        });

        this.topBoxes.boxOneText =
          "Total Hours By " + this.selectContextObject.name;
        this.topBoxes.boxOnePeriod = "This Month";
        this.topBoxes.boxOneValue = staffHours;

        this.topBoxes.boxTwoText =
          "Total Payout To " + this.selectContextObject.name;
        this.topBoxes.boxTwoPeriod = "This Month";
        this.topBoxes.boxTwoValue = staffPayout;
      }
    },
    async getAllClients() {
      const clients = await clientsJs.getAllClients();
      if (clients.length > 0) {
        this.clients = [];
        clients.forEach((client) => {
          this.clients.push({
            text: `${client.name} [${client.id_number}]`,
            value: client,
          });
        });
      }
    },
    async getAllStaff() {
      const staff = await staffJs.getAllStaff();
      if (staff.length > 0) {
        this.allStaffOriginalObjs = staff;
        this.allStaffForSelect = [];
        staff.forEach((st) => {
          this.allStaffForSelect.push({
            text: `${st.name} [${st.id_number}]`,
            value: st,
          });
        });
      }
    },
    openAddClient() {
      this.dialogContext = "add-client";
      this.dialog = true;
      this.dialogTitle = "Add " + this.clientLabel;
    },
    openAddStaff() {
      this.dialogContext = "add-staff";
      this.dialog = true;
      this.dialogTitle = "Add Staff";
    },
    openAddInvoice() {
      this.dialogContext = "add-invoice";
      this.dialog = true;
      this.dialogTitle = "Create Invoice";
      this.maxWidth = "1600";
    },
    closeDialog() {
      this.dialogContext = null;
      this.dialog = false;
      this.dialogTitle = "";
      this.maxWidth = "550";
    },
    setUserEmis() {
      axios
        .postDataWithToken(
          "/auth/get-selected-company",
          { emis: this.getUserCompany.emis },
          this.getAccessToken
        )
        .then((data) => {
          if (data == "unauthorized") {
            this.overlay = true;
            this.unauthorized = true;
          } else {
            this.$store.commit("setUserCompany", data.company);
            this.$store.commit("setCurrency", data.company.currency);
            this.$store.commit("setCompanyLabels", data.company.labels);
            this.$store.commit("setThemeColor", data.company.primary_bg_color);
            this.$store.commit(
              "setSecondaryColor",
              data.company.secondary_bg_color
            );
            this.$store.commit("setAppName", data.company.name);
            this.$store.commit("setCurrentUser", data.user);

            localStorage.setItem("themeColor", data.company.primary_bg_color);
            localStorage.setItem(
              "secondaryColor",
              data.company.secondary_bg_color
            );

            localStorage.setItem("currency", data.company.currency);
            localStorage.setItem("appName", data.company.name);
            localStorage.setItem("userCompany", JSON.stringify(data.company));
            localStorage.setItem(
              "companyLabels",
              JSON.stringify(data.company.labels)
            );

            // this.tilesObj = baronjs.filterTiltes(this.tiles);
            this.getLogos(data.company.emis);
            //this.filterTiltes(data.company);
            this.overlay = false;
          }
        });
    },
    getLogos(emis) {
      axios
        .postData("/get-logos-for-given-company", {
          folder: "logos",
          emis: emis,
        })
        .then((images) => {
          this.images = images;
          if (images && images.length > 0) {
            this.$store.commit(
              "setLogo",
              this.getApiUrl +
                "/images/logos/" +
                this.getUserCompany.emis +
                "/" +
                images[0]
            );
            localStorage.setItem(
              "logo",
              this.getApiUrl +
                "/images/logos/" +
                this.getUserCompany.emis +
                "/" +
                images[0]
            );
          }
        });
    },
  },
};
</script>
